import { Component } from '@angular/core';
import { MainIndexComponent } from './main-index/main-index.component';

import { AuthenticationService } from '../services/authentication.service';
import { MainHomeComponent } from './main-home/main-home.component';

@Component({
    selector: 'app-main',
    imports: [MainIndexComponent, MainHomeComponent],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss'
})
export class MainComponent {
  constructor(private authenticationService: AuthenticationService) { }
  viewMainHome(): boolean {
    return this.authenticationService.isLoggedIn;
  }
}
